module.exports = __webpack_public_path__ + "static/media/Dlouha_hora.bcdd5090.md";